class UserDetailsModel{
    agentCode : string;
    mobile : string;
    email:string;
    isActive:boolean;
    entityId:number;
    entityType:number;
    userName:string;
    unionId:number;
    entityCode:string;
    password:string;
    
    
}
export default UserDetailsModel;